import React, { useState, useRef, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Toast } from "primereact/toast";

// context
import AuthContext from "../../contexts/authContext";
import { UserData } from "../../contexts/UserInfoContext";

// API
import { postData, apiURL, getData } from "../../services/API";

// components
import Loading from "../../components/shared/Loading";
import NoticeMsg from "../../components/shared/NoticeMsg";
import Input from "../../components/shared/Form/Input";

// forms
import config from "./config.json";

// functions
import { CheckError } from "./checkError";
import { idGenerator } from "../../helper/helper";

// icons
import { HiOutlineEye } from "react-icons/hi";

const Password = () => {
  const [showPassword, setShowPassword] = useState(false);
  const { setUser } = useContext(UserData);
  const authContext = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [wrongPassword, setWrongPassword] = useState({});
  const [validate, setValidate] = useState("");
  const [err, setErr] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const toastLogin = useRef(null);

  const navigate = useNavigate();
  // forms & api
  const {
    api_url: { p_login, g_user_profile },
  } = config;

  const { register, getValues } = useForm();

  const passwordInput = [];

  const registerInputes = new Map(Object.entries(p_login.input));

  registerInputes.forEach((item, value) => {
    passwordInput.push(
      <Input
        key={idGenerator}
        element={"input"}
        type={showPassword ? "text" : "password"}
        label={item.label}
        className="text-lg placeholder:text-sm !pl-12"
        placeHolder={`${item.label} خود را وارد کنید`}
        register={{ ...register("password") }}
        error={wrongPassword && wrongPassword["password"]}
      />
    );
  });

  const submitHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    setErr(false);
    setWrongPassword({});

    !loading &&
      postData(
        p_login.url,
        {
          phone_number: authContext.userInfo.phone_number,
          ...getValues(),
          ord: "$2y$10$a0tQbs7S6OgfrgvKU9PmCuGKmj1/YlNSbrkrZxWhjoFD4M.1OJYlu",
        },
        false
      )
        .then((res) => {
          // get user data
          authContext.userLogin(res.data);

          getData(g_user_profile.url, {}, true)
            .then((res) => {
              setLoading(false);

              if (res.data.user.role === 2) {
                setUser(res.data);
                navigate("/");
              } else {
                toastLogin.current.show({
                  severity: "error",
                  summary: "ورود غیرمجاز",
                  detail: "سطح دسترسی شما مجاز نمیباشد",
                  life: 3500,
                });
              }
            })
            .catch((err) => {
              setLoading(false);
            });
        })
        .catch((error) => {
          setLoading(false);
          if (error.response.data.status === "error") {
            setErr(true);
            setErrMsg(error?.response?.data.message);
          }
          setWrongPassword(error?.response?.data);
        });
  };

  return (
    <div className="">
      <Toast ref={toastLogin} />

      {err && <NoticeMsg msg={errMsg} notice={"error"} />}

      <form
        onSubmit={submitHandler}
        className={`verify-code flex flex-col gap-4 mt-6 transition-all duration-300`}
      >
        {/* password input */}
        <div className="relative">
          {passwordInput}

          <div
            onClick={() => setShowPassword(!showPassword)}
            className="cursor-pointer outline-none border-none absolute top-[43px] left-3"
          >
            {showPassword ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-6 h-6 stroke-[#2f52ef]"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-6 h-6 stroke-[#2f52ef]"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
            )}
          </div>
        </div>

        <button
          className="bg-blue scaleAnimation animate-delay-2 opacity-0 text-white w-full h-11 rounded-xl   transition-all duration-300"
          type="submit"
        >
          {!loading ? (
            "ورود به حساب کاربری"
          ) : (
            <Loading color={"before:!bg-white"} />
          )}
        </button>
      </form>
    </div>
  );
};

export default Password;
